import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { UserStateService } from '@core/services/user-state/user-state.service';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { AppFormFieldErrorDirective } from '@shared/directives/app-form-field-error.directive';
import { finalize, first } from 'rxjs';
import { NotificationService } from '@shared/services/notifications/notification.service';
import { TwoFactorAuthenticationService } from '../../service/two-factor-authentication.service';
import { MultiFactorError } from '@angular/fire/auth';
import { getFirebaseErrorMessage } from '@core/services/auth-firebase/firebase-error-map';

@Component({
  selector: 'app-re-authentication',
  standalone: true,
  imports: [ButtonModule, ReactiveFormsModule, AppFormFieldErrorDirective],
  templateUrl: './re-authentication.html',
  styleUrls: ['./re-authentication.scss'],
})
export class ReAuthenticationComponent {
  form: FormGroup;
  hidePassword: boolean = true;
  submitting: boolean = false;
  email: string = '';
  type: 'enroll' | 'unenroll' = 'enroll';

  constructor(
    private fb: FormBuilder,
    private userStateService: UserStateService,
    private twoFactorService: TwoFactorAuthenticationService,
    public ref: DynamicDialogRef,
    private notificationService: NotificationService,
    private config: DynamicDialogConfig
  ) {
    this.email = this.userStateService.currentUser()?.email || '';
    this.type = this.config.data?.type || 'enroll';
    this.form = this.fb.group({
      email: [
        { value: this.email, disabled: true },
        [Validators.required, Validators.email],
      ],
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(16),
        ],
      ],
    });
  }

  onHandleDeactivation(error: MultiFactorError): void {
    this.twoFactorService.setResolver(error);
    this.ref.close(true);
    this.twoFactorService.openDeactivateDialog();
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.submitting = true;
    this.twoFactorService
      .reauthenticateWithPassword({
        email: this.email,
        password: this.form.value.password,
      })
      .pipe(
        first(),
        finalize(() => (this.submitting = false))
      )
      .subscribe({
        next: () => {
          this.ref.close(true);
          this.twoFactorService.openQrEnableDialog();
        },
        error: (error) => {
          if (error.code === 'auth/multi-factor-auth-required') {
            this.onHandleDeactivation(error);
            return;
          }

          this.notificationService.show(
            'Error',
            'Error al reautenticar - detalles: ' +
              getFirebaseErrorMessage(error.code),
            'error'
          );
        },
      });
  }

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }
}